
import { mapGetters } from 'vuex'
const VueMediaQueryMixin = {
  install(Vue) {

    Vue.mixin({
      // components: {
      //   vmqm
      // },
      computed: {
        ...mapGetters(['mediaQuery']),
        windowHeight(){
          return this.mediaQuery.windowHeight
        },
        windowWidth(){
          return this.mediaQuery.windowWidth
        },
        wXS(){
          return this.mediaQuery.wXS
        },
        wSM(){
          return this.mediaQuery.wSM
        },
        wMD(){
          return this.mediaQuery.wMD
        },
        wLG(){
          return this.mediaQuery.wLG
        },
        wXL(){
          return this.mediaQuery.wXL
        }
      },      
      data: function () {
        return {
        }
      }
    })
  }
}


export default VueMediaQueryMixin
